module.exports = __webpack_public_path__ + "img/main-collage.sm.f3af5e88.jpg";